import React from "react"
import HorizontalField, {optionalHorizontalField} from "../HorizontalField/HorizontalField"
import {Accordion} from "../Accordion/Accordion"
import {
	InformationHiding,
	ssnPreview,
	phonePreview,
	emailPreview,
	datePreview,
} from "../InformationHiding/InformationHiding"
import {addressText} from "../../utilities/helpers"
import {Officer} from "../../resources/application"
import moment from "moment"

interface OfficerInformationBusinessProductApplicationProps {
	officer: Officer
	defaultInformationHidingState: boolean
}

export default function OfficerInformationBusinessProductApplication({
	officer,
	defaultInformationHidingState,
}: OfficerInformationBusinessProductApplicationProps) {
	return (
		<div className="card">
			<div className="card-header">
				<p className="card-header-title">Officer Information</p>
			</div>
			<div className="card-content">
				{officer.fullName && (
					<HorizontalField label="Name">
						<input
							type="text"
							readOnly
							value={`${officer.fullName.first} ${officer.fullName.last}`}
							className="input is-static"
						/>
					</HorizontalField>
				)}
				{optionalHorizontalField("Title", officer.title)}
				{officer.ssn || officer.maskedSSN ? (
					<HorizontalField label="SSN">
						<InformationHiding
							element={(value) => <input type="text" readOnly value={value} className="input is-static" />}
							getValue={() => officer.ssn || officer.maskedSSN || ""}
							placeholder={ssnPreview(officer.maskedSSN || officer.ssn || "")}
							defaultIsHidden={defaultInformationHidingState}
							isHiddenIconVisible={true}
						/>
					</HorizontalField>
				) : undefined}
				{officer.passport || officer.maskedPassport ? (
					<HorizontalField label="Passport">
						<InformationHiding
							element={(value) => <input type="text" readOnly value={value} className="input is-static" />}
							getValue={() => officer.passport || officer.maskedPassport || ""}
							placeholder={ssnPreview(officer.maskedPassport || officer.passport || "")}
							defaultIsHidden={defaultInformationHidingState}
							isHiddenIconVisible={true}
						/>
					</HorizontalField>
				) : undefined}
				{officer.matriculaConsular || officer.maskedMatriculaConsular ? (
					<HorizontalField label="Matricula Consular">
						<InformationHiding
							element={(value) => <input type="text" readOnly value={value} className="input is-static" />}
							getValue={() => officer.matriculaConsular || officer.maskedMatriculaConsular || ""}
							placeholder={ssnPreview(officer.maskedMatriculaConsular || officer.matriculaConsular || "")}
							defaultIsHidden={defaultInformationHidingState}
							isHiddenIconVisible={true}
						/>
					</HorizontalField>
				) : undefined}
				{optionalHorizontalField("Nationality", officer.nationality)}
				{officer.dateOfBirth && (
					<HorizontalField label="Birth Date">
						<InformationHiding
							element={(value) => <input type="text" readOnly value={value} className="input is-static" />}
							getValue={() => moment(officer.dateOfBirth).format("YYYY-MM-DD")}
							placeholder={datePreview()}
							defaultIsHidden={defaultInformationHidingState}
							isHiddenIconVisible={true}
						/>
					</HorizontalField>
				)}
				{officer.address && (
					<HorizontalField label="Address">
						<textarea
							readOnly
							value={addressText(officer.address)}
							rows={officer.address.street2 ? 4 : 3}
							className="textarea is-static has-fixed-size"
						/>
					</HorizontalField>
				)}
				{officer.phone ? (
					<HorizontalField label="Phone">
						<InformationHiding
							element={(value) => <input type="text" readOnly value={value} className="input is-static" />}
							getValue={() => `+${officer.phone?.countryCode} ${officer.phone?.number}`}
							placeholder={phonePreview(`+${officer.phone?.countryCode} ${officer.phone?.number}`)}
							defaultIsHidden={defaultInformationHidingState}
							isHiddenIconVisible={true}
						/>
					</HorizontalField>
				) : undefined}
				{officer.email ? (
					<HorizontalField label="Email">
						<InformationHiding
							element={(value) => <input type="text" readOnly value={value} className="input is-static" />}
							getValue={() => officer.email || ""}
							placeholder={emailPreview(officer.email)}
							defaultIsHidden={defaultInformationHidingState}
							isHiddenIconVisible={true}
						/>
					</HorizontalField>
				) : undefined}
				<Accordion title={"Additional Information"} theme={"light"} noContentPadding={true}>
					{optionalHorizontalField("Occupation", officer.occupation)}
					{optionalHorizontalField("Annual Income", officer.annualIncome)}
					{optionalHorizontalField("Source of Income", officer.sourceOfIncome)}
				</Accordion>
			</div>
		</div>
	)
}
